/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

import { register } from 'register-service-worker'
import Vue from 'vue'
import Vuetify from './plugins/vuetify'

// Create a Vue instance just for notifications
const notificationVue = new Vue({
  vuetify: Vuetify,
  data: {
    showUpdateNotification: false
  },
  methods: {
    showRefreshUI() {
      this.showUpdateNotification = true
      
      // Create a notification element
      const snackbar = document.createElement('div')
      snackbar.className = 'v-snackbar v-snackbar--active v-snackbar--bottom v-snackbar--has-action'
      snackbar.style.position = 'fixed'
      snackbar.style.zIndex = '1000'
      snackbar.style.bottom = '0'
      snackbar.style.left = '50%'
      snackbar.style.transform = 'translateX(-50%)'
      snackbar.style.backgroundColor = '#323232'
      snackbar.style.color = '#fff'
      snackbar.style.padding = '14px 40px'
      snackbar.style.borderRadius = '4px'
      snackbar.style.margin = '12px'
      snackbar.style.display = 'flex'
      snackbar.style.alignItems = 'center'
      snackbar.style.boxShadow = '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'
      
      const message = document.createElement('div')
      message.textContent = 'New content is available!'
      message.style.marginRight = '16px'
      
      const button = document.createElement('button')
      button.textContent = 'Refresh'
      button.style.color = '#4CAF50'
      button.style.textTransform = 'uppercase'
      button.style.border = 'none'
      button.style.background = 'transparent'
      button.style.cursor = 'pointer'
      button.style.fontWeight = 'bold'
      button.style.padding = '8px'
      button.addEventListener('click', () => {
        window.location.reload()
      })
      
      snackbar.appendChild(message)
      snackbar.appendChild(button)
      document.body.appendChild(snackbar)
      
      // Remove after 10 seconds if not clicked
      setTimeout(() => {
        if (document.body.contains(snackbar)) {
          document.body.removeChild(snackbar)
        }
      }, 10000)
    }
  }
})

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      
      // Check for updates every 30 minutes
      setInterval(() => {
        registration.update()
      }, 1000 * 60 * 30)
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available; please refresh.')
      notificationVue.showRefreshUI()
      
      // Optionally force reload when essential updates happen
      // Uncomment this to force reload on update
      // window.location.reload(true)
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
} 